'use client';

import { ThemeProvider } from '@repo/design-system';
import type * as React from 'react';

export function WebsiteThemeProvider({ children }: { children: React.ReactNode }): React.ReactNode {
  return <ThemeProvider>{children}</ThemeProvider>;
}
